export default __webpack_public_path__ + "31aef8f0ccd0f6e948a62d12f044db29.png";